import React from 'react';
import { Row } from 'antd';

export const DetailContainer = (props: any) => {
  return (
    <Row
      style={{ display: 'flex', flexFlow: 'nowrap', width: '100%', overflow: 'hidden', height: 'calc(100% - 58px)' }}>
      {props.children}
    </Row>
  );
};
